import styled from '@emotion/styled';
import React, { useState } from 'react';
import { mergeProps, useButton, useFocus } from 'react-aria';

import { Glyph } from '../../common/Glyph';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

export function SelectPreview(props) {
  const button = useButton(props.select.triggerProps, props.previewRef);
  const [isFocused, setIsFocused] = useState(false);
  const focus = useFocus({
    onFocusChange: setIsFocused,
  });

  return (
    <S.Input
      {...mergeProps(button.buttonProps, focus.focusProps)}
      ref={props.previewRef}
      title={props.state.selectedItem?.textValue}
      data-is-open={props.state.isOpen}
      data-is-focused={isFocused}
    >
      <S.Span {...props.select.valueProps}>
        {props.state.selectedItem?.value.icon && (
          <S.SelectedIcon
            source={props.state.selectedItem?.value.icon}
            size={theme.icon.size_default}
            color={theme.color.icon_dark}
          />
        )}
        <S.Text>{props.state.selectedItem?.textValue}</S.Text>
      </S.Span>
      <S.ChevronDownIcon
        source={glyph.core.chevronDownBold}
        color={theme.color.icon_light}
        size={theme.icon.size_small}
      />
    </S.Input>
  );
}

function S() {}
SelectPreview.S = S;

S.Input = styled.button`
  position: relative;
  display: inline-grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  grid-gap: ${su(1)};
  min-width: 0;
  width: 100%;
  height: 40px;
  padding: 3px ${su(1)};
  background-color: ${theme.color.component};
  outline: 0;
  cursor: pointer;
  border: 1px solid ${theme.input.border};
  border-radius: ${theme.input.border_radius};

  &[data-is-open='true'],
  &[data-is-focused='true'] {
    border: 1px solid ${theme.input.border_focus};
  }
`;

S.Span = styled.span`
  display: flex;
  grid-gap: 6px;
  align-items: center;
  min-width: 0;
  width: 100%;
  overflow: hidden;
`;

S.SelectedIcon = styled(Glyph)`
  flex: 0 0 auto;
`;

S.Text = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
`;

S.ChevronDownIcon = styled(Glyph)`
  flex: 0 0 ${theme.icon.size_tiny};
`;
